import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!/Android/i.test(navigator.userAgent)) return
    if (window.matchMedia("(display-mode: standalone)").matches) return

    try {
      if (sessionStorage.getItem("002-app-install-dismissed")) return
    } catch (_) {
      // Still offer the app when browser storage is unavailable.
    }

    this.element.hidden = false
  }

  dismiss() {
    this.element.hidden = true
    try {
      sessionStorage.setItem("002-app-install-dismissed", "1")
    } catch (_) {
      // Dismissal still works for the current page without storage.
    }
  }
}
